import { render } from "./ClientInfo.vue?vue&type=template&id=010b1cd7"
import script from "./ClientInfo.vue?vue&type=script&lang=js"
export * from "./ClientInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__